import React, { } from 'react';
import ImageComponent from '../Image/imageComponent';
import moment from 'moment';
import { DateWithTimeFormate } from '../platformTableComponent/dateFormat';
import { DateFormat } from '../platformTableComponent/dateFormat';
import styles from "./infoCard.module.scss";
import GoogleMaps from '../../components/googleMaps/googleMaps';
import { useTranslation } from 'react-i18next';
import DocumentComponent from '../Image/documentComponent';
import VideoComponent from '../Image/videoComponent';
import { Typography } from 'antd';

const { Text } = Typography

interface RecordProps {
  viewForm: any,
  value: string,
  dataType?: string,
  template?: any,
  downloadAPI?: string
}

const InfoCardRecord: React.FC<RecordProps> = ({
  viewForm,
  value,
  template
}) => {

  const { t } = useTranslation();
  //If display is false do not return card
  if (viewForm.hasOwnProperty("display") && !viewForm.display) {
    return <></>;
  }

  const isImage = (url: string = "") => {
    return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
  }

  const isPDF = (url: string = "") => {
    return /\.(pdf)$/.test(url);
  }

  let files: string[] = [];

  if (viewForm.multiFileDisplay) {
    if (value && value.length > 0) {
      files = value.replace("{", "").replace("}", "").split(",");
    }
  }


  if (viewForm.type === "date") {
    value = moment(value || null).format(DateFormat) ===
      "Invalid date"
      ? value
      : moment(value).format(DateFormat);
  }

  if (viewForm.type === "time") {
    value = moment(value || null).format(DateWithTimeFormate) ===
      "Invalid date"
      ? value
      : moment(value).format(DateWithTimeFormate);
  }

  if (isImage(value)) {
    viewForm.type = "image";
    files.push(value);
  }

  if (isPDF(value)) {
    viewForm.type = "document";
    files.push(value);
  }


  if (viewForm.type === "image" || viewForm.type === "document" || viewForm.multiFileDisplay) {

    return (
      <div className='mb-2'>
        <Text className={"my-0 font-semibold text-sm d-block " + styles.label} style={{ color: template?.labelColor }}>{viewForm.displayName}</Text>
        <Text onClick={ev => ev.stopPropagation()}>
          {files.length > 0 && (
            files.map((item, key) =>
              <span style={{ paddingRight: "4px" }}>
                {isPDF(item) ? <DocumentComponent
                  key={key}
                  src={viewForm.downloadApi + "/"}
                  alt="Image"
                  title={item}
                  URLloaded={false}
                  type={"document"}
                /> : (isImage(item) ? <ImageComponent
                  key={key}
                  src={viewForm.downloadApi + "/"}
                  alt="Image"
                  title={item}
                  URLloaded={false}
                  type={"image"}
                /> : <VideoComponent src={viewForm.downloadApi + "/"} onPreviewClosed={() => { }} title={item} URLloaded={false}></VideoComponent>)}

              </span>

            )
          )}
        </Text>
      </div>

    )
  } else if (viewForm.mapIcon && value) {
    return <GoogleMaps address={value} color={template?.dataColor} displayHeader={viewForm.displayName} />;
  }
  else {
    return (
      <div className='mb-2'>
        <Text className={"my-0 font-medium text-sm d-block " + styles.label} style={{ color: template?.labelColor }}>{t(viewForm.displayName)}</Text>
        <Text className={"my-0 font-medium text-sm d-block "} style={{ color: template?.dataColor }}> {t(value) || <Text className='text-xs opacity-5' >Not available</Text>} </Text>
      </div>
    )
  }
}

export default React.memo(InfoCardRecord);